import { connect } from 'react-redux';
import PolicyScreenPage from 'pages/PolicyScreenPageNew';
import termsAndConditionsActions from 'store/termsAndConditions/actions';

const mapStateToProps = state => {
  return {
    isPolicyDetailsLoading: state?.termsAndConditions?.loadingPolicyDetails,
    policyDetails: state?.termsAndConditions?.policyDetails,
    ipAddress: state?.termsAndConditions?.ipAddress,
    isSignInloading: state?.termsAndConditions?.loadingTermsData,
    signInData: state?.termsAndConditions?.termsData,
  };
};
const mapDispatchToProps = {
  loadPolicyDetails: termsAndConditionsActions.Creators.getPolicyDetailsRequest,
  loadIpAddress: termsAndConditionsActions.Creators.getIpAddressRequest,
  handleSignIn: termsAndConditionsActions.Creators.uploadTermsDataRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(PolicyScreenPage);
